<template>
  <b-modal
    :id="`modal${random}`"
    :no-close-on-esc="true"
    :cancel-disabled="false"
    :ok-disabled="false"
    :hide-header="hideHeader"
    :hide-footer="true"
    :no-close-on-backdrop="true"
    style="z-index: 1050"
    v-model="isShow"
    ref="modal"
    centered
    :title="title"
    size="huge"
    title-class="modal-title"
    header-class="modal-header"
    @show="onShow"
    @close="closeModal"
  >
    <div class="modal-body-setting scroll position-relative" :style="{ width: width + 'px', height: height + 'px' }">
      <div class="modal-content">
        <slot v-if="!isControlledByRoute" />
        <router-view v-else @closeEvent="closeModal" v-on="$listeners" />
      </div>
    </div>
    <div v-if="!noFooter" class="d-flex justify-content-between" style="gap: 12px; padding: 12px 10px 10px 10px">
      <slot name="leftFooter-space">&nbsp;</slot>
      <span v-if="saveBtn || cancelBtn"
        >
        <slot name="cancel-btn">
          <vxe-button v-if="cancelBtn" size="small" status="info" @click="cancel">{{ cancelBtnName }}</vxe-button>
        </slot>
        <slot name="save-btn"
          ><vxe-button v-if="saveBtn" :disabled="saveBtnDisable" size="small" @click="save"
            ><i class="material-icons">save</i>{{ saveBtnName }}</vxe-button
          >
        </slot>
      </span>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: 'Modal',
  props: {
    isOpen: {
      type: Boolean
    },
    title: {
      type: String
    },
    isControlledByRoute: {
      type: Boolean
    },
    focusOn: {
      type: Boolean,
      default: false
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '300'
    },
    height: {
      type: String,
      default: '300'
    },
    saveBtnName: {
      type: String,
      default: '儲存'
    },
    cancelBtnName: {
      type: String,
      default: '取消'
    },
    saveBtn: {
      type: Boolean,
      default: true
    },
    saveBtnDisable: {
      type: Boolean,
      default: false
    },
    cancelBtn: {
      type: Boolean,
      default: true
    },
    noFooter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      routeName: '',
      isShow: false,
      modalTitle: '',
      random: Math.random()
    }
  },
  mounted () {},
  methods: {
    closeModal (bvModalEvt) {
      this.$nextTick(() => {
        this.isShow = false
        this.$emit('closeEvent')
        if (this.isControlledByRoute) {
          this.$router.push({
            name: this.$route.matched[this.$route.matched.length - 1].parent.name,
            params: this.$route.params
          })
        }
      })
    },
    onShow () {
      // this.$nextTick(() => {
      //   let modal = document.getElementById(`modal${this.random}`)
      //   modal.addEventListener('mousedown', () => {
      //     if (this.focusOn === false) {
      //       if (event.target.id === `modal${this.random}`) {
      //         this.closeModal()
      //         this.$emit('closeEvent')
      //       }
      //     }
      //   })
      // })
    },
    cancel () {
      this.$emit('cancel')
      this.closeModal()
    },
    save () {
      this.$emit('save')
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (newVal, oldVal) {
        if (!this.$route.meta.isModal || !this.isControlledByRoute) return
        this.modalTitle = this.$route.meta.isModal ? this.$route['meta']['alias'] : this.title
        this.isShow = true
      }
    },
    isOpen: function (newVal, oldVal) {
      this.isShow = newVal
      if (!newVal) this.closeModal()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/atom/Modal.vue